<template>
  <div class="reference-filter-header px-4 py-3" v-on="$listeners">
    <div>
      {{ label }}
      <v-badge v-if="count" class="badge" :content="count" inline />
    </div>
    <div>
      <v-icon size="16">{{ expanded ? 'remove' : 'add' }}</v-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReferenceFilterHeader',
  props: {
    label: {
      type: String,
      required: true,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: null,
    },
  },
  emits: ['click'],
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

$header-border: 1px solid map-get($grey, 'lighten-2');

.reference-filter-header {
  display: flex;
  justify-content: space-between;

  color: map-get($grey, 'base');
  font-size: 14px;
  font-weight: 500;

  background-color: map-get($grey, 'lighten-5');
  border-top: $header-border;

  cursor: pointer;
  user-select: none;

  &:hover {
    background-color: map-get($grey, 'lighten-4');
  }

  .badge {
    transform: scale(0.8);
  }
}
</style>
